import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import GalleryViewer from '../components/GalleryViewer'
import ContactFormSection from '../components/ContactFormSection'

export default function Renovation() {
  useEffect(() => {
    document.title = 'Renovering - Kristensen Byg og Montage ApS'
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Professionel renovering af boliger, ombygninger, tilbygninger og specialløsninger. Jeg sikrer kvalitet og godt håndværk gennem hele processen.'
      )
    }
  }, [])

  const getResizedUrl = (url, width, quality = 80) => {
    if (!url || !url.startsWith('https://assets.auxodev.dk/')) return url
    return url.replace(
      'https://assets.auxodev.dk/',
      `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=auto/`
    )
  }

  const mainImage = 'https://assets.auxodev.dk/assets/8ba53ab1-a105-4ab3-8373-4041e8d1e44e/renovation-modern-kitchen.jpg'

  return (
    <div className="bg-white min-h-screen">
      {/* Service Details */}
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Column: Content */}
          <div className="space-y-6">
            <h3 className="text-2xl sm:text-3xl font-bold uppercase tracking-wider text-anthracite">
              Giv din bolig nyt liv med professionelt tømrerarbejde
            </h3>
            <p className="text-sm sm:text-base text-warm-gray-600 leading-relaxed">
              En renovering handler ikke kun om at forny overflader, men om at optimere din boligs funktionalitet, lysindfald og energiudnyttelse. Hos Kristensen Byg og Montage ApS har jeg stor erfaring med at føre både mindre og større renoveringsprojekter sikkert i mål.
            </p>
            <p className="text-sm sm:text-base text-warm-gray-600 leading-relaxed">
              Jeg lægger vægt på godt håndværk og kvalitet gennem hele processen – fra de første streger og materialevalg til den sidste finish. Jeg rådgiver dig gerne om, hvordan du bevarer husets sjæl, samtidig med at du opdaterer det til moderne standarder.
            </p>

            {/* List of services */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
              <div className="flex items-start gap-3">
                <i className="fa-light fa-check text-black mt-1 text-base" />
                <span className="text-sm font-semibold text-warm-gray-800">Renovering af boliger</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="fa-light fa-check text-black mt-1 text-base" />
                <span className="text-sm font-semibold text-warm-gray-800">Ombygninger</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="fa-light fa-check text-black mt-1 text-base" />
                <span className="text-sm font-semibold text-warm-gray-800">Tilbygninger</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="fa-light fa-check text-black mt-1 text-base" />
                <span className="text-sm font-semibold text-warm-gray-800">Specialløsninger</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="fa-light fa-check text-black mt-1 text-base" />
                <span className="text-sm font-semibold text-warm-gray-800">Fokus på godt håndværk</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="fa-light fa-check text-black mt-1 text-base" />
                <span className="text-sm font-semibold text-warm-gray-800">Kvalitet gennem hele processen</span>
              </div>
            </div>

            <div className="pt-6">
              <Link
                to="/kontakt"
                className="inline-flex items-center justify-center rounded bg-brand-green px-5 py-2.5 text-sm font-bold text-white shadow-sm hover:bg-brand-green-hover transition-colors duration-200"
              >
                Kontakt mig
              </Link>
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="relative aspect-4/3 overflow-hidden border border-warm-gray-200 shadow-md">
            <img
              src={getResizedUrl(mainImage, 800, 80)}
              alt="Moderne renoveret dansk køkken i høj kvalitet"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      </div>

      {/* Gallery Section */}
      <div className="bg-warm-gray-50 border-t border-b border-warm-gray-200 py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h3 className="text-2xl sm:text-3xl font-bold uppercase tracking-wider text-anthracite">
              Udvalgte renoveringsprojekter
            </h3>
          </div>

          {/* CMS Gallery Viewer */}
          <GalleryViewer slug="renovering" />
        </div>
      </div>

      {/* Contact Form Section */}
      <ContactFormSection
        title="Går du med renoveringstanker?"
        subtitle="Lad os tage en uforpligtende snak om dine planer. Jeg rådgiver gerne om materialer, tidsplaner og konstruktioner, så du får det bedste resultat."
      />
    </div>
  )
}
